<template>
    <div>
        <div class="title-row">
            <div class="page-title">衣橱批量传</div>
            <div class="btn" @click="showCreateModal">创建新任务</div>
        </div>
        
        <at-modal title="创建批量任务" v-model="createModalVisible" @ok="createTask">
            <div class="search-label">输入用户ID</div>
            <div>
                <at-input class="full-with" placeholder="请输入用户ID" v-model="searchMemberId"></at-input>
            </div>
        </at-modal>
        
        <div>
            <a-table
                class="stock-table"
                :columns="table.columns"
                :data-source="table.data"
                :loading="table.loading"
                :pagination="table.pagination"
                :rowKey="record => record.id || record.key"
                @change="tableChanged"
                bordered
            >
                <div slot="idx" slot-scope="val,item">
                    {{ (query.page - 1) * 20 + table.data.indexOf(item) + 1 }}
                </div>
                
                <div slot="time" slot-scope="time">
                    {{ formatTime(time) }}
                </div>
                
                <div slot="avatar" slot-scope="val,item">
                    <img :src="item.ast_member.avatar" alt="" class="avatar">
                </div>
                
                <div slot="nickname" slot-scope="val,item">
                    <at-member-name :member="item.ast_member"></at-member-name>
                </div>
                
                <div slot="status" slot-scope="val,item">
                    {{ item.is_finished ? '已完成' : '进行中' }}
                </div>
                
                <div slot="op" slot-scope="val,item">
                    
                    <button class="btn mr-2" @click="gotoDetail(item)">查看</button>
                    <button class="btn" @click="deleteItem(item)">删除</button>
                
                </div>
            </a-table>
        
        
        </div>
    </div>
</template>

<script>
import api from "../../../repo/api";
import moment from 'moment';
import AtMemberName from "@/components/AtMemberName.vue";
import AtModal from "@/components/AtModal.vue";
import AtInput from "@/components/AtInput.vue";

export default {
    name: "GoodsSync",
    components: {AtInput, AtModal, AtMemberName},
    data() {
        return {
            table: {
                columns: [
                    {
                        title: '序号',
                        dataIndex: 'id',
                        align: 'center',
                    },
                    {
                        title: '用户ID',
                        dataIndex: 'ast_member.member_id',
                        align: 'center',
                    },
                    {
                        title: '用户头像',
                        dataIndex: 'avatar',
                        scopedSlots: {customRender: 'avatar'},
                        align: 'center',
                    },
                    {
                        title: '用户昵称',
                        dataIndex: 'nickname',
                        scopedSlots: {customRender: 'nickname'},
                        align: 'center',
                    },
                    {
                        title: '状态',
                        dataIndex: 'status',
                        scopedSlots: {customRender: 'status'},
                        align: 'center',
                    },
                    {
                        title: '创建时间',
                        dataIndex: 'created_at',
                        align: 'center',
                        scopedSlots: {customRender: 'time'},
                    },
                    {
                        title: '操作',
                        dataIndex: 'op',
                        align: 'center',
                        scopedSlots: {customRender: 'op'},
                    }
                ],
                loading: false,
                data: [],
                pagination: {
                    defaultCurrent: 1,
                    current: 1,
                    defaultPageSize: 10,
                    total: 1,
                    pageSize: 20
                },
            },
            list: [],
            fileName: '',
            query: {
                page: 1
            },
            createModalVisible: false,
            searchMemberId: "",
        }
    },
    mounted() {
        this.getFirstList()
    },
    methods: {
        showCreateModal() {
            this.searchMemberId = '';
            this.createModalVisible = true
        },
        gotoDetail(item) {
            let path = `/ast/wardrobe-task/${item.id}`
            this.$router.push(path)
        },
        async deleteItem(item) {
            
            const [, res] = await this.$uniConfirm({
                title: "确定要删除这个任务吗？",
                content: "删除后不可恢复",
            })
            
            if (!res.confirm) return;
            
            this.$loading.show()
            
            const response = await api.post('/ast-wardrobe-job/del-job', {id: item.id});
            
            this.$loading.hide()
            
            if (response.code !== 0) return;
            
            this.getList()
        },
        async createTask() {
            if (!this.searchMemberId) {
                return this.$message.error('请输入用户ID')
            }
            
            this.$loading.show()
            
            const response = await api.post('/ast-wardrobe-job/create-job', {member_id: this.searchMemberId});
            
            this.$loading.hide()
            
            this.$message.data(response)
            
            if (response.code !== 0) return;
            
            this.gotoDetail(response.data)
        },
        getFirstList() {
            this.query.page = 1
            this.getList()
        },
        getList() {
            
            this.table.loading = true
            
            api.get('/ast-wardrobe-job/jobs', this.query, (data) => {
                
                this.table.data = data.data.data
                this.table.pagination.current = data.data.current_page
                this.table.pagination.total = data.data.total
                this.table.pagination.pageSize = data.data.per_page
                
                this.table.loading = false
                
            })
        },
        formatTime(time) {
            return moment(time).format('yyyy-MM-DD HH:mm')
        },
        
        tableChanged(pagination) {
            this.query.page = pagination.current
            this.getList()
        }
    }
}
</script>

<style lang="less" scoped>
.mt16 {
    margin-top: 16px;
}

.title-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 26px;
    
    .page-title {
        margin: 0;
    }
    
}

.overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 999;
    display: flex;
    align-items: center;
    justify-content: center;
    
    .content {
        width: 1028px;
        height: 548px;
        background: linear-gradient(180deg, #FFFFFF 0%, #EBF2FD 100%);
        display: flex;
        align-items: center;
        justify-content: center;
        position: relative;
        
        .close-btn {
            position: absolute;
            top: 0;
            right: 0;
            cursor: pointer;
            padding: 24px;
            
            img {
                width: 16px;
                height: 16px;
            }
        }
        
        .left {
            width: 347px;
            height: 388px;
            background: #FFFFFF;
            border-radius: 12px;
            border: 1px solid #D2DCF6;
            margin-right: 40px;
            
            .title {
                width: 100%;
                font-size: 16px;
                font-weight: bold;
                color: #333333;
                line-height: 52px;
                text-align: center;
                border-bottom: 1px solid #EEEEEE;
            }
            
            .qrcode-box {
                margin-top: 24px;
                
                .qrcode-title {
                    width: 100%;
                    font-size: 14px;
                    color: #333333;
                    line-height: 20px;
                    text-align: center;
                }
                
                .qrcode-img {
                    width: 100%;
                    height: 256px;
                    margin-top: 16px;
                    text-align: center;
                    
                    img {
                        width: 256px;
                        height: 256px;
                    }
                }
            }
        }
        
        .right {
            width: 513px;
            height: 388px;
            background: linear-gradient(180deg, #D1DBF6 0%, #E6E9F9 100%);
            border-radius: 12px;
            
            .img-row {
                width: 100%;
                display: flex;
                align-items: center;
                justify-content: space-between;
                margin-top: 40px;
                padding: 0 88px;
            }
            
            .img-item {
                width: 149px;
                height: 308px;
                
                img {
                    width: 149px;
                    height: 308px;
                }
            }
            
            .img-title {
                width: 100%;
                
                text-align: center;
                margin-top: 13px;
                
                span {
                    color: #FF0000;
                    font-size: 14px;
                    font-weight: bold;
                    line-height: 20px;
                    
                    &:nth-child(2) {
                        color: #333333;
                    }
                }
                
                
            }
        }
    }
}

.member-card {
    display: flex;
    align-items: center;
    align-content: center;
    flex-direction: row;
    
    img {
        width: 24px;
        height: 24px;
        margin-right: 4px;
    }
    
    .member-name {
        font-size: 14px;
        font-weight: 400;
        color: #333333;
        line-height: 20px;
        overflow: hidden;
        height: 20px;
        flex: 1;
    }
}

.cj {
    color: #FBB03B;
}

.yc-only .member-name {
    color: #FBB03B;
}

.remark {
    width: 100px;
    font-size: 14px;
    font-weight: 400;
    color: #333333;
    line-height: 20px;
}

.member-id {
    height: 20px;
    text-align: center;
    background-color: #ddd;
    font-size: 12px;
    margin-top: 5px;
    color: white;
    position: relative;
    padding: 2px 2px 2px 10px;
    
    &:before {
        position: absolute;
        left: 5px;
        content: ' ID ';
    }
}

.export {
    position: relative;
    top: -50px;
    display: inline-block;
}

.avatar {
    width: 36px;
    height: 36px;
    border-radius: 50%;
}

.search-label {
    margin-bottom: 18px;
    font-weight: 500;
    font-size: 12px;
    color: #666666;
}

</style>